export default function (props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
            <rect width="50" height="50" rx="7" fill="white" />
            <path
                d="M27.0058 23.3293L26.9814 23.3569L27.0026 23.3871L35.624 35.6674H29.3573L23.5286 27.3664L23.4944 27.3176L23.4551 27.3624L16.1547 35.6674H14.3893L22.6872 26.2301L22.7116 26.2024L22.6904 26.1722L14.3758 14.3326H20.6425L26.1599 22.1903L26.1941 22.239L26.2335 22.1943L33.15 14.3326H34.9155L27.0058 23.3293ZM23.564 25.1439L23.564 25.1439L24.4129 26.3309L24.413 26.331L30.1859 34.415L30.1999 34.4347H30.224H33.1279H33.219L33.166 34.3605L26.0897 24.4584L26.0897 24.4583L25.2443 23.2713L25.2443 23.2713L19.7997 15.6529L19.7857 15.6333H19.7615H16.8576H16.7665L16.8195 15.7074L23.564 25.1439Z"
                fill="black"
                stroke="white"
                strokeWidth="0.09375"
            />
        </svg>
    );
}
